import { Filters, UriFilter } from './models/filter';
import { RAW_DURATION_LABELS, RAW_DURATION_MAPPING, RAW_DURATION_VALUES } from './constants';

export const getSkillFilterOptions = (skills: UriFilter[]) =>
  skills.map((skill) => ({
    label: skill.name,
    value: skill.name,
  }));

// Converts localized skill metadata into a key-value map to display the locale label
export function getSkillLocaleLabelMapping(skills: { label: string; value: string }[]): Record<string, string> {
  return Object.fromEntries(skills.map((skill) => [skill.value, skill.label]));
}

export type DurationFilterOption = {
  value: string;
  label: string;
};

export const rawDurationFilters: DurationFilterOption[] = [
  { label: RAW_DURATION_LABELS.LT20, value: RAW_DURATION_VALUES.LT20 },
  { label: RAW_DURATION_LABELS.MID, value: RAW_DURATION_VALUES.MID },
  { label: RAW_DURATION_LABELS.GT60, value: RAW_DURATION_VALUES.GT60 },
];

// Transforms the rawDuration filter to avoid using special characters for UI display
export const transformRawDurationFilter = (rawDuration: Filters['rawDuration']): string[] | undefined =>
  rawDuration?.reduce<string[]>((acc, rawDuration) => {
    const mapping = RAW_DURATION_MAPPING[rawDuration];
    if (mapping) {
      acc.push(mapping);
    }
    return acc;
  }, []);
